export default class SocketService {
    /**
     * 单例
     */
    static instance = null
    // 初始化websocket
    static get Instance () {
      if (!this.instance) {
        this.instance = new SocketService()
      }
      return this.instance
    }
    // 和服务端连接的socket对象
    ws = null
    // 存储回调函数
    callBackMapping = {}
    // 标识是否主动断开
    isBreakClose = true
    // 标识是否连接成功
    connected = false
    // 记录重试的次数
    sendRetryCount = 0
    // 重新连接尝试的次数
    connectRetryCount = 0
    //url
    initUrl = null
    //心跳包定时执行的引用
    heartbeatTimeout = null
    //  定义连接服务器的方法
    connect (url) {
      // 连接服务器
      if (!window.WebSocket) {
        return console.log('您的浏览器不支持WebSocket')
      }
      if(url != null) this.initUrl = url;
      //this.ws = new WebSocket('ws://localhost:8081/pound/wsHandler/123156561')
      this.ws = new WebSocket(url)
      // 连接成功的事件
      this.ws.onopen = () => {
        console.log('连接服务端成功了')
        this.connected = true
        this.isBreakClose = false
        // 重置重新连接的次数
        this.connectRetryCount = 0;
        //启动心跳包
        this.heartbeatStartSend();
      }
      // 1.连接服务端失败
      // 2.当连接成功之后, 服务器关闭的情况
      this.ws.onclose = () => {
        console.log('客户端断开连接')
        // 如果是手动断开的,那么就不再继续连接
        if(this.isBreakClose) return;
        this.connected = false
        this.connectRetryCount++
        setTimeout(() => {
          this.connect(this.initUrl)
        }, 500 * this.connectRetryCount)
      }
      // 得到服务端发送过来的数据
      this.ws.onmessage = msg => {
        // 真正服务端发送过来的原始数据时在msg中的data字段
        const recvData = JSON.parse(msg.data)
        const protocol= recvData.protocol;
        // console.log("收到消息-------", msg, recvData);
        //收到消息,重置心跳包
        if(this.heartbeatTimeout){
          this.reset().heartbeatStartSend();
        }
        // 判断回调函数是否存在
        if (this.callBackMapping[protocol]) {
            this.callBackMapping[protocol].call(this, recvData)
        }
      }
    }
    // 手动断开websocket
    breakCloseWs(){
      // 标识为主动断开
      this.isBreakClose = true
      // 停止心跳包
      this.reset()
      // 清空回调函数
      this.callBackMapping = {}
      this.ws.close()
    }
    // 回调函数的注册
    registerCallBack (protocol, callBack) {
      this.callBackMapping[protocol] = callBack
    }
  
    // 取消某一个回调函数
    unRegisterCallBack (protocol) {
      this.callBackMapping[protocol] = null
    }

    //心跳包发送消息
    heartbeatStartSend(){
      if(this.heartbeatTimeout){
        this.reset();
      }
      //每55000毫秒执行一次
      this.heartbeatTimeout = setInterval(() => {
          console.log("发送心跳消息保持连接....");
          this.send({code:200, protocol:"heartbeat", msg:"心跳包heartbeat"});
      }, 60000)
    }
    //心跳包清除
    reset(){
        clearTimeout(this.heartbeatTimeout);
        return this;
    }
  
    // 发送数据的方法
    send (data) {
      // 判断此时此刻有没有连接成功
      if (this.connected) {
        this.sendRetryCount = 0
        this.ws.send(JSON.stringify(data))
      } else {
        this.sendRetryCount++
        setTimeout(() => {
          this.send(data)
        }, this.sendRetryCount * 500)
      }
    }
  }
  
  